// import axios from "axios";

export const state = {
    t_menuList: [], //产品模板启用list
    updateTemplate: '', // 更新模板的时间戳
};

export const getters = {
    t_menuList: state => state.t_menuList ||  sessionStorage.getItem('t_menuList'),
    updateTemplate: state => state.updateTemplate || sessionStorage.getItem('updateTemplate'),
};

export const mutations = {
    setTMenuList(state, newValue) {
        state.t_menuList = newValue
        // console.log(newValue);
        sessionStorage.setItem('t_menuList', JSON.stringify(newValue))
    },
    setupdateTemplate(state, newValue) {
        state.updateTemplate = newValue
        sessionStorage.setItem('updateTemplate', newValue)
    },
};

// export const actions = {
//     fetchTodos({ commit }) {
//         axios.get('https://jsonplaceholder.typicode.com/todos').then(res => {
//             commit('setTodos', res.data)
//         })
//     },
// };
